import {Injectable, Component} from '@angular/core';
import {Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Commission} from './commission.model';
import {CommissionService} from './commission.service';
@Injectable()
export class CommissionPopupService {
    private isOpen = false;
    constructor (
        private modalService: NgbModal,
        private router: Router,
        private commissionService: CommissionService

    ) {}

    open (component: Component, campagneId: number, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.commissionService.find(id).subscribe(commission => {
                // commission.dateCommission = this.datePipe.transform(commission.dateCommission, 'yyyy-MM-ddThh:mm');
                // commission.datePublication = this.datePipe.transform(commission.datePublication, 'yyyy-MM-ddThh:mm');
                // commission.dateCoupure = this.datePipe.transform(commission.dateCoupure, 'yyyy-MM-ddThh:mm');
                this.commissionModalRef(component, campagneId, commission);
            });
        } else {
            return this.commissionModalRef(component, campagneId, new Commission());
        }
    }

    commissionModalRef(component: Component, campagneId: number, commission: Commission): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.commission = commission;
        modalRef.componentInstance.campagneId = campagneId;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/commission/commission-popup.service.ts